import { Settings as LayoutSettings } from '@ant-design/pro-components';
/**
 * @name
 */
export const themeSettings: LayoutSettings & {
  pwa?: boolean;
  logo?: string;
  token?: any;
  siderWidth: number;
} = {
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: '云栈管理平台',
  pwa: false,
  siderWidth: 208,
};
